import NavComponent from "../lib/nav_component";

export const PaneInfoComponentConfig = {
    componentTypeKey: 'PaneInfoComponent',
    baseHtmlClass: 'nav_option__info',
    selector: '.nav_option__info',

    clickedEventName: 'PaneInfoComponent-clicked',
};

export class PaneInfoComponent extends NavComponent {

    static new(parentElement, paneOptionComponent) {
        let element = parentElement.querySelector(PaneInfoComponentConfig.selector);
        if (!element) { return }
        return new PaneInfoComponent(element, paneOptionComponent);
    }

    constructor(id_or_element, paneOptionComponent) {
        super(id_or_element, PaneInfoComponentConfig);
        this.paneOptionComponent = paneOptionComponent;
        this.element.addEventListener('click',this.handleClick.bind(this));
    }

    /**
     * Communicates with the native app or online app to ensure the map is configured correctly.     *
     * Pane Info Click Event Process:
     *
     * Prevents the default action unless we're within the native app context where the URL load will be handled by the native app routes.
     *
     * Dispatches the "clicked" event on the element which is picked up by the `OnlineAppNavOption` component which will handle URL updates and setting the OnlineApp's map filter etc.
     *
     * Dispatches the 'paneInfoClick' action where the pane option is selected and the Nav's map filter state is set.
     */
    handleClick(event) {
        // The default action (URL load) is not prevented for native app context where the URL load will be handled by the native app routes and the map filter will be set.
        if (this.paneOptionComponent.shouldPreventDefaultAction()) event.preventDefault();

        // Dispatch the clicked event on the element, which will be picked up by the `OnlineAppNavOption` component which will handle URL updates and setting the OnlineApp's map filter etc.
        this.element.dispatchEvent(new CustomEvent(PaneInfoComponentConfig.clickedEventName));

        this.dispatchAction("paneInfoClick", this);
    }

    /**
     * Determines if the associated Pane should be opened when the component is clicked.
     * If there is an associated pane then it should always be opened when the PaneInfoComponent is clicked.
     * @return {boolean} If the associated Pane should be opened.
     */
    shouldOpenPane() {
        if (!this.paneOptionComponent.hasAssociatedPane()) { return false } // Should not open the Pane when there is no associated Pane.
        return true;
    }

}
